let store = require("../store");
let actions = require("../actions");

let Blip = mc.widgets.Blip;
let IconButton = mc.widgets.IconButton;
let QuickSearch = mc.widgets.QuickSearch;
let Table = mc.widgets.Table;

let StudyFormView = require("./StudyFormView");

class StudyListView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let { studies, studyStats, prefs } = store.getState();

    return {
      studies,
      studyStats,
      prefs
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    actions.loadStudies(store.getState().accountId);
    actions.loadStudyStats(store.getState().accountId);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  createStudy(evt) {
    StudyFormView.open(null);
  }

  setTerm(term) {
    this.setState({ term });
  }

  submitTerm(result) {
    mc.router.trigger("DESIGN_STUDY_VIEW", { studyId: result.id });
  }

  sortStudies(key, direction) {
    actions.setPrefs({
      "studyListSortKey": key,
      "studyListSortDirection": direction
    });
  }

  render() {
    let { studies, studyStats, prefs } = this.state;
    let term = this.state.term || "";
    let sortKey = prefs.studyListSortKey || "displayName";
    let sortDirection = prefs.studyListSortDirection || 1;

    let results = mc.utils.filter(studies, ["displayName", "title"], term);

    let rows = results.map(function (study) {
      study.countSubjects = (studyStats[study.id] || {}).countSubjects || 0;

      return study;
    });

    let cols = [
      {
        prop: "displayName",
        label: tx("study"),
        content: (function (study) {
          let href = mc.router.resolve("DESIGN_STUDY_VIEW", { studyId: study.id });

          let colors = {
            INITIALIZED: "#eee",
            IN_PROGRESS: "#00bc43",
            COMPLETE: mc.ui.colors.NAVY
          };

          let tooltip = tx("lifecycleState." + study.lifecycleState);

          return (
            <Blip color={colors[study.lifecycleState]} tooltip={tooltip}>
              <a href={href}>
                {study.displayName}
              </a>
            </Blip>
          );
        }).bind(this),
        width: "25%",
        sort: mc.utils.sortIgnoreCase(function (row) {
          return row.displayName;
        }),
        clip: true
      },
      {
        prop: "title",
        label: tx("description"),
        width: "45%",
        sort: false,
        clip: true
      },
      {
        prop: "createdTs",
        label: tx("created"),
        content: function (study) {
          return mc.format.date(study.createdTs);
        },
        width: "20%",
        sort: true
      },
      {
        prop: "countSubjects",
        label: tx("subjects"),
        content: function (study) {
          return study.countSubjects;
        },
        width: "10%",
        sort: true
      }
    ];

    return (
      <div className="rc-study-list-view">
        <div className="mc-split-layout" style={{ marginBottom: "1em" }}>
          <QuickSearch
            term={term}
            results={rows}
            onChange={this.setTerm.bind(this)}
            onSubmit={this.submitTerm.bind(this)}
            placeholder={tx("search")}/>
          <IconButton
            id="rc-study-list-view-new"
            icon="plus"
            scale={1.5}
            label={tx("new_study")}
            onPress={this.createStudy.bind(this)}/>
        </div>
        <div className="mc-card">
          <Table
            id="rc-study-list-view-results"
            data={rows}
            cols={cols}
            align="middle"
            sort={sortKey}
            direction={sortDirection}
            onSort={this.sortStudies.bind(this)}/>
        </div>
      </div>
    );
  }
}

module.exports = StudyListView;